import React from 'react';
import './Hero.css'; 
import heroVideo from '../assets/videos/hero.mp4';


function Hero() {

  const handleHardRefresh = (path) => {
    window.location.href = path;
  };

  return (
    <section className="hero">

      <video
        className="hero-video"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={heroVideo} type="video/mp4" />
      </video>

      <div className="hero-overlay"></div>

      <div className="hero-content">
        <h1>SpaceTimeAI</h1>
        <h1>Science + System + Societal Impact</h1>
        <p>
          Turning spatial data into real-time intelligence for resilient,
          safer, and sustainable cities.
        </p>

        <div className="cta-buttons">
          <button 
            className="cta-button"
            onClick={() => handleHardRefresh("/solutions")}
          >
            Explore Solutions
          </button>
          <button 
            className="cta-button"
            onClick={() => handleHardRefresh("/book")}
          >
            Book a Demo
          </button>
          <button 
            className="cta-button"
            onClick={() => handleHardRefresh("/success-stories")}
          >
            Success Stories
          </button>
        </div>
      </div>

    </section>
  );
}

export default Hero;